import React, { useState } from 'react';
import { Clock, Calendar, Tag } from 'lucide-react';
import { articles } from '../mock';

const Articles = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const categories = ['All', 'Apologetics', 'Free Grace Theology'];

  const filteredArticles = selectedCategory === 'All'
    ? articles
    : articles.filter(article => article.category === selectedCategory);

  return (
    <div className="page-container">
      <section className="section-container">
        <h1 className="display-large page-title">Articles</h1>
        <p className="body-large page-subtitle">
          In-depth theological and apologetic articles with exegetical analysis.
        </p>

        {/* Category Filter */}
        <div className="article-filters">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`filter-btn ${selectedCategory === category ? 'active' : ''}`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Articles Grid */}
        <div className="articles-list">
          {filteredArticles.map((article) => (
            <div key={article.id} className="article-list-card">
              <div className="article-card-header">
                <span className="article-category-tag">{article.category}</span>
                <div className="article-date">
                  <Calendar size={14} />
                  <span className="body-small">{article.date}</span>
                </div>
              </div>
              
              <h3 className="heading-2">{article.title}</h3>
              <p className="body-medium article-excerpt">{article.excerpt}</p>
              
              <div className="article-card-footer">
                <div className="meta-item">
                  <Clock size={14} />
                  <span className="body-small">{article.readTime}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {filteredArticles.length === 0 && (
          <div className="no-results">
            <p className="body-large">No articles found for this category.</p>
          </div>
        )}
      </section>
    </div>
  );
};

export default Articles;
